import React, { useCallback, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import {
  format,
  setHours as setDateHours,
  setMinutes as setDateMinutes,
  getHours,
} from 'date-fns';
import { SelectOption } from '../../../Select/types';
import { useDateTimePicker } from '../..';
import { Container, Spacer, StyledInput, StyledSelect } from './styled';
import { Schema, schema12HourMode, schema24HourMode } from './schema';

const timePeriodOptions = [
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'PM',
    value: 'PM',
  },
];

export const TimeSelection = () => {
  const { selectedValue, setSelectedValue, use12HourMode, t } =
    useDateTimePicker();
  const modeRef = useRef<boolean>(use12HourMode);

  const { values, errors, submitForm, setFieldValue, handleChange } =
    useFormik<Schema>({
      onSubmit: ({ hours, timePeriod, minutes }) => {
        const m = minutes ? parseInt(`${minutes}`, 10) : 0;
        let h = hours ? parseInt(`${hours}`, 10) : 0;

        if (modeRef.current && timePeriod === 'PM') {
          h += 12;
        }
        setSelectedValue(setDateHours(setDateMinutes(selectedValue, m), h));
      },
      validationSchema: modeRef.current ? schema12HourMode : schema24HourMode,
      enableReinitialize: true,
      initialValues: {
        hours: parseInt(
          format(selectedValue, modeRef.current ? 'hh' : 'HH'),
          10,
        ),
        minutes: parseInt(format(selectedValue, 'mm'), 10),
        timePeriod: getHours(selectedValue) >= 13 ? 'PM' : 'AM',
      },
    });

  const handleTimePeriodSelect = useCallback(
    (option?: SelectOption) => {
      setFieldValue('timePeriod', option?.value);
    },
    [setFieldValue],
  );

  useEffect(() => {
    submitForm();
  }, [values, submitForm]);

  return (
    <Container>
      <StyledInput
        label={t('hour')}
        name="hours"
        onChange={handleChange}
        value={values.hours}
        error={errors.hours}
        type="number"
        min="0"
        max="23"
      />
      <Spacer>:</Spacer>
      <StyledInput
        label={t('minutes')}
        name="minutes"
        onChange={handleChange}
        value={values.minutes}
        error={errors.minutes}
        type="number"
        min="0"
        max="59"
      />
      {modeRef.current && (
        <StyledSelect
          selected={{
            value: values.timePeriod,
            label: values.timePeriod || '',
          }}
          onSelect={handleTimePeriodSelect}
          error={errors.timePeriod}
          options={timePeriodOptions}
        />
      )}
    </Container>
  );
};
